module.exports = __webpack_public_path__ + "img/pleat bottom width.9e9d6fce.png";